<template>
  <b-modal
    id="lastroundfeedback"
    centered
    hide-footer
    hide-header
    class="p-0"
    size="md"
    no-close-on-backdrop
    @hidden="closeFeedback()"
  >
    <div class="mb-3">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="modal-head-pan">Give Feedback</span>
        <div @click="closeFeedback()">
          <img
            src="../../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            class="pointer rotate-on-hover"
          />
        </div>
      </div>
      <hr style="position: absolute; width: 600px; left: -1px" />
    </div>
    <div class="submodal-body py-3 px-2">
      <div class="position-relative" v-if="showRecOptions">
        <SelectCustom
          :mandatory="true"
          :placeholder="'Select'"
          :values="getFilteredRecOptions"
          :dropdown="true"
          @select-value="updateValue"
          :vmodel="$v.feedback.recOption.$model"
          :label="'Recommendation'"
          :showError="$v.feedback.recOption.$error"
        />
        <div v-if="$v.feedback.recOption.$error" class="error-txt-tc">
          Required
        </div>
      </div>
      <div v-else class="mr-2">
        <b-form-group
          class="panlogradio"
          :class="{
            'panlogradio-err':
              $v.feedback.recommendation.$dirty &&
              !$v.feedback.recommendation.required,
          }"
          v-slot="{ ariaDescribedby }"
        >
          <div class="modal-subheads">
            Recommendation<span class="asterik">*</span>
          </div>
          <div
            class="
              fdf-add-container
              mt-2
              w-75
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              value="S"
              :disabled="viewfeedback"
              >Select</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="viewfeedback"
              value="H"
              >Hold</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="viewfeedback"
              value="R"
              >Reject</b-form-radio
            >
            <b-form-radio
              v-model="feedback.recommendation"
              :aria-describedby="ariaDescribedby"
              name="some-radios"
              :disabled="viewfeedback"
              value="DNA"
              >No Show</b-form-radio
            >
          </div>
        </b-form-group>
      </div>
      <div>
        <div class="mt-3">
          <label class="modal-subheads-pts"
            >Remarks<span class="asterik">*</span></label
          >
          <b-form-textarea
            class="remarks-panlog mt-2"
            type="text"
            rows="3"
            v-model.trim="$v.recruiterRemarks.$model"
            :class="{ 'remarks-panlog-err': $v.recruiterRemarks.$error }"
            placeholder="Enter"
            max-rows="6"
          >
          </b-form-textarea>
          <div v-if="!$v.recruiterRemarks.maxLength" class="error-txt-tc">
            Exceeded the max char length of 256
          </div>
          <div v-else-if="$v.recruiterRemarks.$error" class="error-txt-tc">
            Required
          </div>
        </div>
      </div>
      <hr style="width: 561px; position: absolute; left: 14px" />
      <div class="mt-3 pt-3 pr-2">
        <div class="modal-subheads">Basic Info</div>
        <div class="mt-3 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Candidate Name</span>
          <div class="basic-info-divs px-2 py-2">{{ interviewCandidate }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Evaluation Date</span>
          <div class="basic-info-divs px-2 py-2">{{ evalDate }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Panel Name</span>
          <div class="basic-info-divs px-2 py-2">{{ panelName }}</div>
        </div>
        <div class="mt-2 d-flex justify-content-between">
          <span class="basic-info-labels mt-2 mr-3">Mode of Interview</span>
          <div class="basic-info-divs px-2 py-2">Face To Face</div>
        </div>
      </div>
    </div>

    <div
      class="d-flex align-items-center mt-3"
      :class="
        showBotAnalysis ? 'justify-content-between' : 'justify-content-end'
      "
    >
      <div
        v-if="showBotAnalysis"
        @click="goToBotAnalysis"
        class="d-flex pointer pl-2"
      >
        <img alt="" class="mr-2" src="@/assets/img/newkanban/botanalysis.svg" />
        <div class="fdbk-his-link">View Bot Analysis</div>
      </div>
      <div class="d-flex">
        <div class="cancelpan-btn mr-3">
          <b-button class="addbtn" @click="closeFeedback">Cancel</b-button>
        </div>
        <div class="addpanellog position-relative">
          <b-button
            :class="buttonLoader ? 'givefeed-loader-class' : 'pointer'"
            class="addbtn"
            @click="!buttonLoader ? lastroundgivefeedback() : ''"
          >
            <span v-if="!buttonLoader"> Send </span></b-button
          >

          <div v-if="buttonLoader" class="loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { getValidations } from "../../panelLogin/validations.js";
import { lastroundgivefeedback } from "../../panelLogin/asynchronous.js";
import toast from "../../../components/mixin/toast";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import SelectCustom from "../../../components/InputComponents/SelectCustom";
import { mapGetters } from "vuex";
export default {
  name: "LastRoundFeedback",
  components: {
    Loader,
    SelectCustom,
  },
  props: {
    viewfeedback: Boolean,
    feedback: Object,
    panelName: String,
    interviewCandidate: String,
    interviewResponse: Object,
    showGiveFeebackButton: Boolean,
    evalDate: String,
    selectedCandidate: Object,
    interviewObject: Object,
  },
  data() {
    return {
      buttonLoader: false,
      recruiterRemarks: "",
      feedbackHistory: [],
      viewScreenshot: "",
      isLaptop: true,
    };
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  mixins: [toast],

  validations() {
    return getValidations(this);
  },
  computed: {
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters({ roles: "roles" }),
    showBotAnalysis() {
      return (
        this.roles.includes("VIEW_CANDIDATE_ANALYSIS") &&
        this.interviewObject.botInfo?.botAnalysisCompleted
      );
    },
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
    getFilteredRecOptions() {
      if (this.showRecOptions) {
        return Object.entries(
          this.thirdPartyData.configuration.feedbackLevelOptions
        ).map(([key, label]) => {
          return { key, label };
        });
      }
      return [];
    },
  },
  methods: {
    goToBotAnalysis() {
      let queryData = {
        intid: this.interviewObject.interviewID,
        type: 1,
        givefeed: true,
        fromPage: this.$route.name,
        candidateID: this.selectedCandidate.candidateID,
        round: this.selectedCandidate.kanbanLevel,
      };
      queryData = {
        ...queryData,
        ...this.$route.query,
      };
      delete queryData.preview;
      this.$emit("storeCandidateData");
      this.$router.push({
        name: "BotAnalysis",
        query: queryData,
      });
    },
    updateValue(data) {
      this.$v.feedback.recOption.$model = data;
      this.$v.feedback.recommendation.$model =
        this.thirdPartyData.configuration.recommendationKey[data];
      this.$forceUpdate();
    },
    closeFeedback() {
      this.recruiterRemarks = "";
      this.$bvModal.hide("lastroundfeedback");
      if (this.$route.query.givefeed) {
        let newQuery = { ...this.$route.query };
        delete newQuery.givefeed;
        delete newQuery.round;
        delete newQuery.candidateID;
        delete newQuery.history;
        this.$router.replace({ path: this.$route.path, query: newQuery });
      }
      this.$v.$reset();
    },
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    async lastroundgivefeedback() {
      this.$v.$touch();
      if (
        !this.$v.feedback.recommendation.$invalid &&
        !this.$v.recruiterRemarks.$invalid
      ) {
        this.buttonLoader = true;
        await lastroundgivefeedback(this);
        this.$emit("giveLastFdbck");
        this.buttonLoader = false;
      } else {
        this.buttonLoader = false;
      }
    },
    closejdDetail() {
      this.$bvModal.hide("jd-detail");
    },
  },
};
</script>
<style scoped>
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 87px;
}
.defaultCursor {
  cursor: default;
}
</style>
